import type { QueryClient } from '@tanstack/react-query';
import { Outlet, createRootRouteWithContext } from '@tanstack/react-router';
import { NotFound } from '@/components/layout/not-found';
import { TooltipProvider } from '@/components/ui/tooltip';
import { useThemeSync } from '@/features/theme/use-theme';

export type RouterContext = {
  queryClient: QueryClient;
};

export const Route = createRootRouteWithContext<RouterContext>()({
  component: Root,
  notFoundComponent: () => (
    <main className="p-6">
      <NotFound />
    </main>
  ),
});

function Root() {
  useThemeSync();
  return (
    <TooltipProvider>
      <Outlet />
    </TooltipProvider>
  );
}
